import React from 'react';

interface SrOnlyTextFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const SrOnlyTextField: React.FC<SrOnlyTextFieldProps> = ({ value, onChange }) => (
  <div>
    <label htmlFor="sr-only-text" className="block text-xs font-medium text-gray-600 mb-1">
      スクリーンリーダー用テキスト
    </label>
    <textarea
      id="sr-only-text"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="h-24 w-full resize-y rounded-md border border-warm-border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
    />
  </div>
);

export default SrOnlyTextField;
